module.exports = __webpack_public_path__ + "static/media/siprc_dot3.ac70bdd4.png";